module.exports = __webpack_public_path__ + "img/zurnal24.de405bea.svg";